export enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  DELETE=  'DELETE',
  PUT = 'PUT'
}